/* PrettyKaly — homepage interactions */

(function () {
  function scrollTargetFor(button) {
    var id = button.getAttribute('data-pk-scroll');
    return id ? document.getElementById(id) : null;
  }

  function scrollByCard(container, direction) {
    var card = container.firstElementChild;
    var amount = card
      ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(container).columnGap || 0)
      : container.clientWidth * 0.8;
    container.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  document.addEventListener('click', function (event) {
    var scrollButton = event.target.closest('[data-pk-scroll]');
    if (scrollButton) {
      var container = scrollTargetFor(scrollButton);
      if (container) {
        scrollByCard(container, scrollButton.getAttribute('data-pk-dir') === 'prev' ? -1 : 1);
      }
      return;
    }

    var wish = event.target.closest('.pk-pcard__wish');
    if (wish) {
      event.preventDefault();
      wish.classList.toggle('is-active');
      wish.setAttribute('aria-pressed', wish.classList.contains('is-active') ? 'true' : 'false');
    }
  });

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-pk-dialog-open]');
    if (!opener) return;
    var dialog = document.getElementById(opener.getAttribute('data-pk-dialog-open'));
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();

    var video = dialog && dialog.querySelector('video');
    if (video && video.paused) video.play().catch(function () {});
  });

  document.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-pk-dialog-close]');
    if (!closer) return;
    var dialog = closer.closest('dialog');
    if (!dialog) return;
    var video = dialog.querySelector('video');
    if (video) video.pause();
    dialog.close();
  });

  document.querySelectorAll('dialog.pk-dialog').forEach(function (dialog) {
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var video = dialog.querySelector('video');
      if (video) video.pause();
      dialog.close();
    });
  });
})();
